import { createAsyncThunk } from '@reduxjs/toolkit';
import { setError } from '../../../redux/slice';

import * as api from '../api';

export const doGetRoutePlanOrders = createAsyncThunk(
  'routePlansOrders/doGetRoutePlanOrders',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.getRoutePlanOrders(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doAddOrderToRoutePlan = createAsyncThunk(
  'routePlansOrders/doAddOrderToRoutePlan',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.addOrderToRoutePlan(params);
      if (error) {
        thunkAPI.dispatch(setError(error));
        return thunkAPI.rejectWithValue(error);
      } else {
        return response;
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);
